import { useForm } from "react-hook-form";
import moment from "moment";

export const useIncidentForm = () => {
  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      incident_date: moment().format("YYYY-MM-DD"),
      incident_time: moment().format("HH:mm"),
      location: "",
      description: "",
      outcome_type: "",
      injuries_occurred: "no",
      body_parts: "",
      injury_cause: [],
      injury_cause_other: "",
      injury_details: "",
      abuse_check: "",
      abuse_details: "",
      treatment_administered: "",
      treatment_administrator: "",
      immediate_actions: "",
      medication_incident_categories: [],
      medication_other_description: "",
      medication_possible_reasons: "",
      medication_immediate_action: "",
      signatory_name: "",
      // Yes/No questions - default to "no" for better UX
      coordinator_notified: "no",
      doctor_notified: "no",
      pharmacist_notified: "no",
      first_aid_given: "no",
      ambulance_needed: "no",
      prn_administered: "no",
      reported_to_police: "no",
      medical_review_offered: "no",
      // Incident Overview new fields
      incident_overview_date: moment().format("YYYY-MM-DD"),
      incident_overview_time: moment().format("HH:mm"),
      incident_address: "",
      incident_address_street: "",
      incident_address_suburb: "",
      incident_address_state: "",
      incident_address_postcode: "",
      incident_location_details: "",
      person_responsible_notified: "no", // Default to "no"
      // Incident Details fields
      executive_summary: "",
      has_behavior_management_plan: "no", // Default to "no"
      regulated_restrictive_practices_used: "no", // Default to "no"
      current_task: "",
      incident_details_narrative: "",
      conclusion: "",
      triggers_circumstances: "",
      immediate_action_taken: "",
      incident_details_witnesses: [
        {
          first_name: "",
          surname: "",
          date_of_birth: null,
          gender: null,
          address: "",
        },
      ],
    },
  });

  return {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    clearErrors,
    errors,
  };
};
